import React from 'react'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import { default as fragments } from '../../fragments'
import { withRouter } from 'react-router-dom'
import auth from '../../auth'

import { Main } from '../../containers'

import {
  Spinner,
  GlobalNavigation,
  Modal,
  EmployerAccountSwitcher,
  CenteredContainerDisplay,
  SvgIcon,
  Heading
} from '../'

import {
  hasResponsibility,
  getCurrentUserResponsibilityRelatedId,
  getNodeTypeFromBase64Id
} from '../../utils'

import { AccountContext } from '../../context'


const setUserResponsibilities = (userResponsibilities) => {
  if (!localStorage.hasOwnProperty('userResponsibilities')) {
    // save user responsibilities
    localStorage.setItem('userResponsibilities', JSON.stringify(userResponsibilities.edges))
  }
}


const setIdentityResponsibilities = (identityResponsibilities) => {
  if (!localStorage.hasOwnProperty('identityResponsibilities')) {
    // save identity responsibilities
    localStorage.setItem('identityResponsibilities', JSON.stringify(identityResponsibilities.edges))
  }
}


const setInitialAccountId = (data, location) => {
  if (location.pathname.includes('employer/')) {
    let idStartIndex = location.pathname.indexOf('employer/') + 9
    let part = location.pathname.substring(idStartIndex)
    let id = part.substring(0, part.indexOf('/'))
    return id
  }

  if (location.pathname.includes('group/')) {
    let idStartIndex = location.pathname.indexOf('group/') + 6
    let part = location.pathname.substring(idStartIndex)
    let id = part.substring(0, part.indexOf('/'))
    return id
  }

  if (data && localStorage.getItem('userResponsibilities') !== 'undefined') {
    if (hasResponsibility('self', 'messageplus_user', 'employergroup')) {
      return getCurrentUserResponsibilityRelatedId('messageplus_user', 'employergroup')
    }
    else {
      return null
    }
  }
}


class Application extends React.Component {
  state = {
    identityInitialised: false,  // necessity of this state variable and localStorage usage below to possibly be replaced with context api
    showChooseEmployerModal: false,
    accountId: setInitialAccountId(this.props.data, this.props.location),  // accountId can be either employer/employergroup id
    switchAccount: (newAccountId) => {
      const currentAccountId = this.state.accountId
      this.setState(
        { accountId: newAccountId },
        () => this.switchAccounts(newAccountId, currentAccountId)
      )
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (auth.loggedIn() && !this.state.identityInitialised && this.props.data.me) {
      const userIdentity = this.props.data.me

      if (!localStorage.hasOwnProperty('userNodeId')) {
        let userEmailAddress = userIdentity.defaultEmailAddress.edges.length > 0
          ? userIdentity.defaultEmailAddress.edges[0].node.addressValue
          : null
        // save user details
        localStorage.setItem('userNodeId', userIdentity.id)
        localStorage.setItem('userEmailAddress', userEmailAddress)

        // set user related responsibilities
        setUserResponsibilities(userIdentity.responsibilities)
        setIdentityResponsibilities(userIdentity.identityResponsibilities)

        if (userIdentity.contacts.edges.length > 0) {
          // does user have employergroup level access?  (all views will be group-level, filters on listing views will allow for specific employer selection)
          if (hasResponsibility('self', 'messageplus_user', 'employergroup')) {
            let employerGroupId = getCurrentUserResponsibilityRelatedId('messageplus_user', 'employergroup')
            this.setState({ accountId: employerGroupId })

            let accessibleEmployerAccounts = this.getAccessibleEmployerAccounts(
              userIdentity.responsibilities,
              userIdentity.contacts
            )

            accessibleEmployerAccounts.push({ [employerGroupId]: 'group' })
            localStorage.setItem(
              'accessibleEmployerAccounts',
              JSON.stringify(accessibleEmployerAccounts)
            )
          }
          // if user doesn't have employergroup level access, evaluate on employer level
          else {
            const accountId = userIdentity.contacts.edges[0].node.employer.id
            this.setState({ accountId })

            localStorage.setItem(
              'accessibleEmployerAccounts',
              JSON.stringify(
                this.getAccessibleEmployerAccounts(
                  userIdentity.responsibilities,
                  userIdentity.contacts
                )
              )
            )
          }
        }
      }

      if (this.state.accountId === null) {
        if (hasResponsibility('self', 'messageplus_user', 'employergroup')) {
          let employerGroupId = getCurrentUserResponsibilityRelatedId('messageplus_user', 'employergroup')
          this.setState({ accountId: employerGroupId })
        }
        else {
          const accountId = userIdentity.contacts.edges[0].node.employer.id
          this.setState({ accountId })
        }
      }

      if (JSON.parse(localStorage.getItem('accessibleEmployerAccounts')).length > 1) {
        // allow account switching on login
        this.toggleChooseEmployerModal()
      }

      this.setState({ identityInitialised: true })
    }
  }

  switchAccounts = (newAccountId, currentAccountId) => {
    // localStorage.setItem('employer', e.target.value)
    const switchFromEmployerAccount = getNodeTypeFromBase64Id(currentAccountId) === 'EmployerNode'
    const switchToEmployerGroupAccount = getNodeTypeFromBase64Id(newAccountId) === 'EmployerGroupNode'

    // switching from specific employer to group account
    if (switchFromEmployerAccount && switchToEmployerGroupAccount) {
      // proceed to determine 'employer/uuid' part of url and replace with newly selecter employer
      let currentPathName = this.props.location.pathname
      let employerPathIndex = currentPathName.indexOf('employer/')
      if (employerPathIndex > -1) {
        // 'employer/uuid part in url and to be replaced'
        let part = currentPathName.substring(employerPathIndex + 9)  // 9 being length of 'employer/'
        let employerId = part.substring(0, part.indexOf('/'))
        let newPathName = currentPathName.replace(employerId, newAccountId) + this.props.location.search
        newPathName = newPathName.replace('employer/', 'group/')
        this.props.history.push(newPathName)
      } else {
        // 'employer/uuid part not in url'
        // window.location.reload()
        console.info('here 1')
      }
    }
    // switching from specific employer to another employer account
    else if (switchFromEmployerAccount && !switchToEmployerGroupAccount) {
      // proceed to determine 'employer/uuid' part of url and replace with newly selecter employer
      let currentPathName = this.props.location.pathname
      let employerPathIndex = currentPathName.indexOf('employer/')
      if (employerPathIndex > -1) {
        // 'employer/uuid part in url and to be replaced'
        let part = currentPathName.substring(employerPathIndex + 9)
        let employerId = part.substring(0, part.indexOf('/'))
        let newPathName = currentPathName.replace(employerId, newAccountId) + this.props.location.search
        this.props.history.push(newPathName)
      } else {
        // 'employer/uuid part not in url'
        // window.location.reload()
        console.info('here 2')
      }
    }
    // switching from group to specific employer account
    else if (!switchFromEmployerAccount && !switchToEmployerGroupAccount) {
      // proceed to determine 'group/uuid' part of url and replace with newly selecter employer
      let currentPathName = this.props.location.pathname
      let employerPathIndex = currentPathName.indexOf('group/')
      if (employerPathIndex > -1) {
        // 'group/uuid part in url and to be replaced'
        let part = currentPathName.substring(employerPathIndex + 6)  // 6 being length of 'group/'
        let employerId = part.substring(0, part.indexOf('/'))
        let newPathName = currentPathName.replace(employerId, newAccountId) + this.props.location.search
        newPathName = newPathName.replace('group/', 'employer/')
        this.props.history.push(newPathName)
        // window.location.reload()
      } else {
        // 'group/uuid part not in url'
        console.info("here 3")
        // window.location.reload()
      }
    }
    else {
      // window.location.reload()
      console.info("catch-all")
    }
  }

  getAccessibleEmployerAccounts = (responsibilities, contacts) => (
    responsibilities.edges.some(({ node: responsibility }) => (
      responsibility.description === 'messageplus_user' &&
      responsibility.relatedModel === 'employer'
    ))
      ? contacts.edges
        .filter(({ node: contact }) => (
          contact.employer !== null
        ))
        .map(({ node: contact }) => (
          { [contact.employer.id]: contact.employer.friendlyName }
        ))
      : []
   )

  toggleChooseEmployerModal = () => (
    this.setState(prevState => ({
      showChooseEmployerModal: !prevState.showChooseEmployerModal
    }))
  )

  setEmployerId = (e) => (
    this.setState({ accountId: e.target.value })
  )

  render() {
    const { accountId, switchAccount, showChooseEmployerModal } = this.state

    if (this.props.data.loading || !this.state.identityInitialised) {
      return <Spinner />
    }

    // don't error if they've not logged in yet
    if (this.props.data.error && auth.loggedIn()) {
      return (
        <CenteredContainerDisplay
          content={
            <div>
              <SvgIcon
                variant='utility'
                symbol='warning'
                size='large'
                colour='error'
                className='slds-align_absolute-center'
              />
              <Heading className='slds-p-top_medium u-no-margin__b'>
                Sorry, this page failed to load the necessary data and therefore cannot be displayed.<br />
                Please refresh your browser and if this message continues to appear please contact us.
              </Heading>
            </div>
          }
          yAdjustPercentage={-20}
        />
      )
    }
    const isEmployerGroupAccount = getNodeTypeFromBase64Id(accountId) === 'EmployerGroupNode'
    return (
      <AccountContext.Provider
        value={{
          currentAccountId: accountId,
          isEmployerGroupAccount,
          switchAccount
        }}>
        <div>
          <GlobalNavigation
            currentAccountId={accountId}
            isEmployerGroupAccount={isEmployerGroupAccount}
            switchAccount={switchAccount}
          />
          <Main />
          {showChooseEmployerModal &&
            <Modal
              body={
                <EmployerAccountSwitcher
                  currentEmployerId={accountId}
                  onSelectionClick={e => switchAccount(e.target.value)}
                  onClick={this.toggleChooseEmployerModal}
                  className='slds-grid'
                  style={{ flexDirection: 'column', alignItems: 'center' }}
                  optionsClassName='u-font-size-larger'
                />
              }
              containerClassName='width-30-percent'
            />
          }
        </div>
      </AccountContext.Provider>
    )
  }
}

const getUser = gql`
  query {
    me {
      ...MyInfo
      defaultEmailAddress: addresses(addressType: "email", default: true) {
        edges {
          node {
            id
            addressValue
          }
        }
      }
      responsibilities {
        edges {
          node {
            id
            description
            relatedModel
            relatedId
          }
        }
      }
      identityResponsibilities {
        edges {
          node {
            id
            responsibilitytype {
              id
            	name
            }
            relatedId
            relatedModel {
              id
              model
            }
          }
        }
      }
    }
  }
  ${fragments.me}
`

const withData = graphql(getUser)

export default compose(
  withData,
  withRouter
)(Application)



// WEBPACK FOOTER //
// ./src/components/application/index.js